// Author YuJiaBei
// Date 2021-12-05 19:24:22

import * as model from "@/model/em/repair/RepairWorkOrderModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.RepairWorkOrder(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_REPAIR_URL,
        callbackApi: process.env.VUE_APP_EM_REPAIR_URL + '/repairWorkOrder/workflow/complete-feedback',
        processDefinitionKey: "em_repair_work_order",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        },
        //附加异常数据
        appendAbnormalDataForEntity(state, data) {
            state.entity = Object.assign(state.entity, data)
        }
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'repairPlanSelectorFilter',
        filterInitializer: newFilter
    })
    .buildStore()
